import React from 'react';

/* Inline diff renderer for writing corrections — strikethrough the student's
   error, green-highlight the fix (lextest-style "Suggested Changes"). */
function buildSegments(text, corrections) {
  const missed = [];
  const ordered = [];
  let cursor = 0;
  corrections.forEach((c) => {
    const idx = text.indexOf(c.original, cursor);
    if (idx === -1) { missed.push(c); return; }
    ordered.push({ ...c, idx });
    cursor = idx + c.original.length;
  });
  const segments = [];
  let pos = 0;
  ordered.forEach((c) => {
    if (c.idx > pos) segments.push({ type: 'text', value: text.slice(pos, c.idx) });
    segments.push({ type: 'fix', original: c.original, corrected: c.corrected, reason: c.reason });
    pos = c.idx + c.original.length;
  });
  if (pos < text.length) segments.push({ type: 'text', value: text.slice(pos) });
  return { segments, missed };
}

export const SuggestedChanges = ({ text, corrections }) => {
  const list = Array.isArray(corrections)
    ? corrections.filter((c) => c && c.original && c.corrected)
    : [];
  if (!text || list.length === 0) return null;
  const { segments, missed } = buildSegments(text, list);
  return (
    <div style={{ padding: '14px 20px', borderTop: '1px solid #eee', background: '#fffefb' }} data-testid="suggested-changes-block">
      <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#1f2937', marginBottom: '8px' }}>
        Suggested Changes
        <span style={{ marginLeft: '8px', fontSize: '11px', fontWeight: 600, color: '#9ca3af' }}>
          {list.length} fix{list.length === 1 ? '' : 'es'}
        </span>
      </div>
      {segments.length > 0 && (
        <div style={{ fontSize: '13.5px', lineHeight: '2', color: '#374151', whiteSpace: 'pre-wrap', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px 14px' }} data-testid="suggested-changes-text">
          {segments.map((s, i) => (s.type === 'text' ? (
            <span key={i}>{s.value}</span>
          ) : (
            <span key={i} title={s.reason || ''}>
              <del style={{ color: '#9ca3af', textDecorationColor: '#cf8f8f' }} data-testid={`sc-del-${i}`}>{s.original}</del>
              {' '}
              <ins style={{ background: '#d3f3df', color: '#14532d', textDecoration: 'none', borderRadius: '3px', padding: '0 3px', fontWeight: 600 }} data-testid={`sc-ins-${i}`}>{s.corrected}</ins>
            </span>
          )))}
        </div>
      )}
      {missed.length > 0 && (
        <div style={{ marginTop: '10px' }} data-testid="suggested-changes-extra">
          {segments.length > 0 && <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '4px' }}>More fixes</div>}
          {missed.map((c, i) => (
            <div key={i} style={{ fontSize: '12.5px', marginBottom: '4px', color: '#374151' }}>
              <del style={{ color: '#9ca3af' }}>{c.original}</del>
              {' → '}
              <span style={{ background: '#d3f3df', color: '#14532d', borderRadius: '3px', padding: '0 3px', fontWeight: 600 }}>{c.corrected}</span>
              {c.reason ? <span style={{ color: '#9ca3af' }}> · {c.reason}</span> : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SuggestedChanges;
